import { render, staticRenderFns } from "./Kuaishou.vue?vue&type=template&id=dc47e432&scoped=true"
import script from "./Kuaishou.vue?vue&type=script&lang=js"
export * from "./Kuaishou.vue?vue&type=script&lang=js"
import style0 from "./Kuaishou.vue?vue&type=style&index=0&id=dc47e432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc47e432",
  null
  
)

export default component.exports